import { render, staticRenderFns } from "./DadosBancariosPix.vue?vue&type=template&id=776af460&"
import script from "./DadosBancariosPix.vue?vue&type=script&lang=js&"
export * from "./DadosBancariosPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports